import { isHidden as n } from "../utils/element.js";
var i = function(e) {
  if (n(e))
    return 1 / 0;
  for (var t = 0, r = e.parentNode; r; )
    t += 1, r = r.parentNode;
  return t;
};
export {
  i as calculateDepthForNode
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js
// module id = 873
// module chunks = 67